import UiLimitPagination from './UiLimitPagination'

export default function install(Vue) {
  Vue.component('ui-limit-pagination', UiLimitPagination)
}
